/**
 * Japanese (JPY) mock schedules for the scheduled-transactions use case.
 * A schedule with both source and destination accounts is a schedule pair,
 * rendered by DoubleRow.
 */

/** @type {Array<import('../../mock-schedules.js').MockSchedule>} */
export const MOCK_SCHEDULES_JA = [
	{
		id: 'sch-1',
		nextDate: '2026-08-27',
		transactionType: 'Credit Card Payment',
		estimatedAmount: 125000,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		displayAccount: 'みどり銀行',
		displayFreq: 'Monthly',
		description: 'クレジットカード支払い',
	},
	{
		id: 'sch-2',
		nextDate: '2026-08-10',
		transactionType: 'Withdrawal',
		estimatedAmount: 80000,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		displayAccount: 'みどり銀行',
		displayFreq: 'Monthly',
		description: '家賃',
	},
	{
		id: 'sch-3',
		nextDate: '2026-08-15',
		transactionType: 'Regular Investment',
		estimatedAmount: 100000,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		displayAccount: 'みどり銀行',
		displayFreq: 'Monthly',
		description: '積立投資',
	},
	{
		id: 'sch-4',
		nextDate: '2026-08-05',
		transactionType: 'Deposit',
		estimatedAmount: 350000,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		displayAccount: 'みどり銀行',
		displayFreq: 'Monthly',
		description: '給与',
	},
	{
		id: 'sch-5',
		isSchedulePair: true,
		nextDate: '2026-09-01',
		transactionType: 'Transfer',
		estimatedAmount: 50000,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		displayAccount: 'みどり銀行',
		displaySourceAccount: 'みどり銀行',
		displayDestAccount: '定期預金',
		displayFreq: 'Monthly',
		description: '貯金へ',
		pairedType: 'Transfer',
		pairedCurrencySymbol: '\u00A5',
		pairedCurrencyDecimalPlaces: 0,
	},
];
